<template>
  <Modal width="90%" :styles="queryConfig.popStyle" :title="myConfig.title" v-model="modalflag" :footer-hide="true" @on-visible-change="ondestroy">
    <div v-if="modalflag">
      <iframe ref="birtreport" :src="myConfig.url" frameborder="0" :height="currentHeight" style="width: 100%" allowtransparency="true"  @load="load"></iframe>
    </div>
  </Modal>
</template>
<script>
import size from '@/components/base/size';
export default {
    name:'birtreportbox',
    mixins: [size],
    data() {
        return {
            myConfig: {
                title: '',
                billmoduleid: '',
                param: {},
                url: '',
                height:0.8
            },
            queryConfig:{
                popStyle:{
                    top:'20px'
                }
            },
            modalflag: false
        };
    },
    methods: {
        setConfig(config) {
            this.myConfig = Object.assign({}, this.myConfig, config);
            this.modalflag = true;
            this.setSizeConfig(this.myConfig);
            this.reflashReportUrl();
        },
        load() {
            if (this.myConfig.onLoad) {
                let iframe = this.$refs.birtreport.$el;
                this.myConfig.onLoad(iframe);
            }
        },
        ondestroy(value) {
            if (!value) {
                if (this.myConfig.onDestroy) {
                    this.myConfig.onDestroy(this.myConfig);
                }
            }
        },
        getReportFile() {
            if (this.myConfig.billmoduleid) {
                let file = '';
                let searchParam = { moduleid: this.myConfig.billmoduleid };
                let method = 'mall.work.reportconfig.search';
                this.synchroPost(this.OmdUrl.mall, method, searchParam,function(data) {
                    if (data && data.reportconfig && data.reportconfig.length > 0) {
                        file = data.reportconfig[0].reportfile;
                    }
                });
                return file;
            }
        },
        getReportUrl() {
            let url = '';
            let file = this.getReportFile();

            if (file) {
                url = file + '&__masterpage=true&__showtitle=false&__format=html&__page=1';
                let paramurl = '';
                for (let key in this.myConfig.param) {
                    paramurl += '&' + key + '=' + this.myConfig.param[key];
                }
                //url拼上__userid，__postid ，增加数据范围
                let userid = this.$Method.getUrlParam('userid');
                if (userid != null && userid != '') {
                    paramurl += '&__userid=' + userid;
                }
                let postid = this.$Method.getUrlParam('postid');
                if (postid != null && postid != '') {
                    paramurl += '&__postid=' + postid;
                }
                paramurl += '&__accesstime=' + new Date().getTime();

                url = encodeURI(url + paramurl);
            }
            return url;
        },
        reflashReportUrl() {
            let url = this.getReportUrl();
            if (url) this.myConfig.url = url;
        }
    },
    mounted(){
        //this._setCustomHeight(this.clientHeight);
        //this._setCustomWidth(this.clientWidth);
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/layouttemplate/birtreportbox.vue